/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';

const style: ouiStyle.InStyleWithMediaQueries = {
  display: ouiStyle.Constants.DisplayProp.flex,
  paddingLeft: 'double',
  backgroundColor: ouiStyle.Constants.Colors.inverted,
  borderTopLeftRadius: 'full',
  borderBottomLeftRadius: 'full',
  borderLeftStyle: 'solid',
  borderLeftWidth: 'simple',
  borderTopStyle: 'solid',
  borderTopWidth: 'simple',
  borderBottomStyle: 'solid',
  borderBottomWidth: 'simple',
  flexGrow: 1,
};

export const ArticleSearchContainer = (props: React.PropsWithChildren<{
  borderColor?: ouiStyle.InStyle['borderColor'],
}>) => {
  const {
    borderColor = ouiStyle.Constants.Colors.inverted,
    children,
  } = props;
  const css = React.useMemo(() => ouiStyle.mediaQuery(ouiStyle.makeCss({
    ...style,
    borderLeftColor: borderColor,
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
  })), [
    borderColor,
  ]);
  return (
    <div
      css={css}
    >
      {children}
    </div>
  );
};
